export const actions = {
  SET_PERMISSIONS: 'SET_PERMISSIONS',
};

export const setPermissions = (data) => ({
  type: actions.SET_PERMISSIONS,
  data,
});
